/* Ask Pip: one conversation, shown in two places.
 *
 * The widget (snippets/pip-widget.liquid) sits on every page; the Ask Pip page
 * (sections/ask-pip.liquid) is the big window. Both draw the same thread, kept
 * in sessionStorage, so "open full screen" carries the conversation across.
 *
 * Pip answers from tms-backend through the app proxy (/apps/tms/pip/chat). The
 * backend decides everything that matters: who is signed in (from Shopify's
 * signed query, never from here), which offers this shopper may see, and which
 * products and book pages are real. This file only draws what comes back.
 * Every "can't answer" comes back as 200 with off/limited/error set, because
 * Shopify's proxy swaps any 5xx for its own HTML error page.
 */
(function () {
  'use strict';

  var cfg = window.PipConfig || {};
  var ENDPOINT = cfg.endpoint || '/apps/tms/pip/chat';
  var BAG_LOG = ENDPOINT.replace(/\/chat$/, '/bag');
  var PAGE = cfg.page || '/pages/ask-pip';
  var KEY = 'tms:pip:thread';
  var OPEN_KEY = 'tms:pip:open';
  var RESUME_KEY = 'tms:pip:resume';
  var RECENT_KEY = 'tms:pip:recent';
  var PENDING_KEY = 'tms:pip:pending';
  /* Inbox (11-02): replies from a person at the store, after Pip handed a shopper over. */
  var INBOX = ENDPOINT.replace(/\/chat$/, '/inbox');
  var INBOX_AT = 'tms:pip:inboxAt';      // when we last asked (at most every few minutes)
  var TO_KEY = 'tms:pip:to';             // {handoff, until}: their next message goes to the person, not Pip
  var TEAM = 'James';
  /* Guests say who they are before the first message (Rich, 11-02): first name, email and the
     Terms + Privacy tick, or Sign in. The backend hands back a pass this browser keeps and sends
     with every message; without it a guest message comes back {gate: true}. */
  var HELLO = ENDPOINT.replace(/\/chat$/, '/hello');
  var PASS_KEY = 'tms:pip:pass';

  /* The last products this browser opened, newest first. Sent with each message so
     "Something I'd like" can lean on what they've been browsing. Stays on this device. */
  function recentList() {
    try { var a = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); return Array.isArray(a) ? a : []; }
    catch (e) { return []; }
  }
  if (cfg.product && cfg.product.handle) {
    try {
      var seenNow = recentList().filter(function (h) { return h !== cfg.product.handle; });
      seenNow.unshift(cfg.product.handle);
      localStorage.setItem(RECENT_KEY, JSON.stringify(seenNow.slice(0, 10)));
    } catch (e) {}
  }
  var MAX_KEEP = 40;

  /* Same browser id as offers.js, so an offer claimed here is the same claim. */
  function browserId() {
    var id = '';
    try { id = localStorage.getItem('tms:browser') || ''; } catch (e) {}
    if (!id) {
      id = 'b' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      try { localStorage.setItem('tms:browser', id); } catch (e) {}
    }
    return id;
  }

  var thread = [];
  try { thread = JSON.parse(sessionStorage.getItem(KEY) || '[]') || []; } catch (e) { thread = []; }
  function save() {
    thread = thread.slice(-MAX_KEEP);
    try { sessionStorage.setItem(KEY, JSON.stringify(thread)); } catch (e) {}
  }

  var views = [];
  var busy = false;
  var slow = false;   // a long answer or a dropped line: "Still thinking…" under the dots

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Pip writes plain text. Allowed: **bold**, [words](link) and bare links - but only
     to this store (or Shopify's own order pages), so nothing in a reply can point
     a shopper somewhere else. A bare order link reads "View your order". */
  var OK_HOST = /^https:\/\/([a-z0-9-]+\.)*(theonlinemagicstore\.com|shopify\.com|myshopify\.com)(\/|$)/i;
  function safeHref(u) {
    u = u.replace(/&amp;/g, '&');
    if (/^\/(?!\/)/.test(u) || OK_HOST.test(u)) return u.replace(/"/g, '%22');
    return '';
  }
  function fmt(text) {
    var out = esc(text)
      .replace(/\*\*(.+?)\*\*/g, '<b>$1</b>')
      .replace(/\[([^\]]+)\]\(((?:https:\/\/|\/)[^)\s]*)\)/g, function (m, words, u) {
        var h = safeHref(u); return h ? '<a href="' + h + '">' + words + '</a>' : words;
      })
      .replace(/(^|[\s(])(https:\/\/[^\s<)]+)/g, function (m, pre, u) {
        var h = safeHref(u.replace(/[.,;:!?]+$/, ''));
        if (!h) return m;
        var tail = u.slice(u.replace(/[.,;:!?]+$/, '').length);
        return pre + '<a href="' + h + '">' + (/\/orders\//.test(h) ? 'View your order' : 'Open link') + '</a>' + tail;
      });
    return out.split(/\n{2,}/).map(function (p) { return '<p>' + p.replace(/\n/g, '<br>') + '</p>'; }).join('');
  }

  function img(u, w) {
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function here() { return location.pathname + location.search; }

  function claimedIds() {
    var ids = [];
    thread.forEach(function (m) {
      ((m.cards && m.cards.offers) || []).forEach(function (o) { if (o.code) ids.push(o.id); });
    });
    return ids;
  }

  function cardsHtml(c, last) {
    if (!c) return '';
    var h = '';
    if (c.products && c.products.length) {
      h += '<div class="pchat-prods">' + c.products.map(function (p) {
        // found = the line a book's own page gives for what's inside it (search_book_contents)
        return '<a href="/products/' + encodeURIComponent(p.handle) + '"' + (p.found ? ' class="has-found"' : p.note ? ' class="has-note"' : '') + '>' +
          (p.image ? '<img src="' + esc(img(p.image, 300)) + '" alt="" decoding="async">' : '<span class="pchat-noimg"></span>') +
          '<b>' + esc(p.title) + '</b><span>' + esc(p.creator || '') + '</span>' +
          (p.found ? '<span class="pchat-found">' + esc(p.found) + '</span>' : '') +
          // Pip's one line on why this card (10-08), so his reply above stays short
          (p.note && !p.found ? '<span class="pchat-why">' + esc(p.note) + '</span>' : '') +
          // no price on Pip's suggestions (Rich 10-06): the product page has it
          (p.available === false ? '<span class="pchat-soldout">Sold out</span>' : '') +
          // the whole card is the link; the button just says so
          (p.found ? '<span class="pchat-buyrow"><span class="pchat-more">Learn more</span></span>' : '') + '</a>';
      }).join('') + '</div>';
    }
    if (c.book_pages && c.book_pages.length) {
      h += '<div class="pchat-books">' + c.book_pages.map(function (b) {
        var src = '/apps/tms/books/page?b=' + encodeURIComponent(b.book) + '&p=' + b.page + '&size=preview';
        return '<a href="/products/' + encodeURIComponent(b.handle) + '"><img src="' + src + '" alt="" decoding="async">' +
          // Rich 10-08: the trick on that page is the card's title, then the book and page, then the
          // sentence or two where what they asked about comes up
          '<div>' + (b.entry ? '<span class="pchat-bt pchat-be">' + esc(b.entry) + '</span>' +
            '<span class="pchat-bm">' + esc(b.title) + ' · page ' + b.page + '</span>'
            : '<span class="pchat-bt">' + esc(b.title) + ' · page ' + b.page + '</span>') +
          '<span class="pchat-bs">' + esc(b.snippet) + (/[.!?…]$/.test(b.snippet || '') ? '' : '…') + '</span></div></a>';
      }).join('') + '</div>';
    }
    (c.offers || []).forEach(function (o) {
      h += '<div class="pchat-offer"><b>' + esc(o.title) + '</b>' + (o.details ? '<p>' + esc(o.details) + '</p>' : '');
      if (o.code) {
        var apply = o.apply_url || '/discount/' + encodeURIComponent(o.code);
        h += '<div class="pchat-code"><span>' + esc(o.code) + '</span><a class="btn" data-pchat-apply href="' + esc(apply + '?redirect=/cart') + '" data-base="' + esc(apply) + '">Apply</a></div>';
      } else if (o.claimable && claimedIds().indexOf(o.id) > -1) {
        h += '<span class="pchat-done">Claimed below</span>';
      } else if (o.claimable) {
        h += '<button class="btn" type="button" data-pchat-claim="' + esc(o.id) + '">Claim it</button>';
      }
      if (o.expires && !o.terms) h += '<small>Ends ' + esc(String(o.expires).slice(0, 10)) + '</small>';
      if (o.terms) h += '<small>' + esc(o.terms) + '</small>';
      h += '</div>';
    });
    (c.instructions || []).forEach(function (x) {
      h += '<div class="pchat-instr"><b>' + esc(x.title) + '</b><span>Online instructions</span>' +
        '<a class="btn" href="' + esc(x.url) + '" target="_blank" rel="noopener">Open instructions</a>' +
        (x.password ? '<div class="pchat-code"><span>' + esc(x.password) + '</span><button type="button" class="pchat-copy" data-pchat-copy="' + esc(x.password) + '">Copy password</button></div>' : '<small>No password needed.</small>') +
        '</div>';
    });
    (c.games || []).forEach(function (g) {
      var line = g.prize ? (g.signed_in ? 'Win ' + g.prize + ' in store credit' : 'Win up to ' + g.prize) : '';
      if (g.signed_in && g.plays_left != null) line += (line ? ' · ' : '') + g.plays_left + ' play' + (g.plays_left === 1 ? '' : 's') + ' left today';
      h += '<div class="pchat-game"><span class="pchat-cards" aria-hidden="true"><i></i><i></i><i></i></span><div><b>' + esc(g.name) + '</b>' +
        (line ? '<p>' + esc(line) + '</p>' : '') + '</div><button class="btn" type="button" data-pchat-game="' + esc(g.url) + '">Play</button></div>';
    });
    return h;
  }

  /* ---- the bag (Rich 10-08): Pip offers, one tap adds or saves; never a "no" button ---- */
  function money(cents, cur) { return '$' + (Number(cents || 0) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + (cur || ''); }

  function bagHtml(c, last) {
    if (!c) return '';
    var h = '';
    if (c.added) {
      h += '<div class="pchat-added">' + (c.added.image ? '<img src="' + esc(img(c.added.image, 120)) + '" alt="">' : '<span class="pchat-noimg"></span>') +
        '<span class="pchat-ok"><i aria-hidden="true"></i>Added to your bag</span>' +
        '<span class="pchat-what">' + esc(c.added.title + (c.added.version ? ' (' + c.added.version + ')' : '')) + ', ' + esc(c.added.price) +
        (c.added.preorder ? '<small class="pchat-pre">Pre-order · ' + esc(c.added.preorder) + '</small>' : '') + '</span></div>';
    }
    if (c.saved) {
      h += '<div class="pchat-added is-saved">' + (c.saved.image ? '<img src="' + esc(img(c.saved.image, 120)) + '" alt="">' : '<span class="pchat-noimg"></span>') +
        '<span class="pchat-ok' + (c.saved.later ? ' is-later' : '') + '"><i aria-hidden="true"></i>' + (c.saved.already ? 'Already in your saves' : c.saved.later ? 'Saving once you sign in' : 'Saved to your list') + '</span>' +
        '<span class="pchat-what">' + esc(c.saved.title) + ' · <a href="/pages/saves">See your saves</a></span></div>';
    }
    if (c.checkout && c.checkout.count != null) {
      var k = c.checkout, cur = k.currency;
      if (!k.count) {
        h += '<div class="pchat-checkout"><span class="pchat-bagsub">Your bag is empty</span></div>';
      } else {
        h += '<div class="pchat-checkout"><b class="pchat-baghead">Your bag</b><ul class="pchat-baglines">' +
          (k.lines || []).map(function (l) {
            return '<li>' + (l.image ? '<img src="' + esc(img(l.image, 80)) + '" alt="">' : '<span class="pchat-noimg"></span>') +
              '<span><b>' + esc(l.title) + (l.qty > 1 ? ' × ' + l.qty : '') + '</b>' +
              (l.version ? '<small>' + esc(l.version) + '</small>' : '') + (l.pre ? '<small>Pre-order · ' + esc(l.pre) + '</small>' : '') +
              '</span><em>' + esc(money(l.price, cur)) + '</em></li>';
          }).join('') + '</ul>' +
          (k.codes || []).map(function (d) {
            return '<p class="pchat-bagrow"><span>' + esc(d.title) + '</span><em>−' + esc(money(d.amount, cur)) + '</em></p>';
          }).join('') +
          '<p class="pchat-bagrow pchat-bagsub"><span>Subtotal</span><em>' + esc(money(k.total, cur)) + '</em></p>' +
          (k.ship ? '<p class="pchat-bagship' + (k.ship.free ? ' is-free' : '') + '">' + esc(k.ship.text) + '</p>' : '') +
          '<p class="pchat-bagnote">Shipping and taxes calculated at checkout</p>' +
          '<a class="pchat-go-out" href="/checkout">Check out now</a>' +
          (k.fill && k.fill.length ? fillHtml(k.fill, k.gapText) : '') + '</div>';
      }
    }
    return h;
  }

  /* The tap buttons under an offer: Add to bag (one per version) and Save for later. */
  function offerHtml(c, last) {
    if (!c || !c.bag || !last || c.bag.done) return '';
    var opts = c.bag.options || [];
    var avail = opts.filter(function (o) { return o.available; });
    var single = avail.length === 1 && !avail[0].version;
    return '<div class="pchat-replies pchat-bagbtns">' + opts.map(function (o, i) {
      if (!o.available) return o.version ? '<button type="button" class="is-out" disabled>' + esc(o.version) + ' <small>sold out</small></button>' : '';
      // a choice shows each version's price on its button: "Add Streaming version · $46.00 CAD"
      return '<button type="button" class="is-add" data-pip-add="' + i + '">' +
        esc(single ? 'Add to bag' : 'Add ' + o.version + (o.price ? ' · ' + o.price : '')) + '</button>';
    }).join('') + '<button type="button" data-pip-save>Save for later</button></div>';
  }

  function lastBag() {
    for (var i = thread.length - 1; i >= 0; i--) if (thread[i].cards && thread[i].cards.bag) return thread[i];
    return null;
  }

  function logBag(kind, item) {
    try {
      fetch(BAG_LOG, { method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
        body: JSON.stringify({ kind: kind, handle: item.handle || '', variant_id: item.variant_id || '',
                               title: item.title || '', price: item.price || '' }) });
    } catch (e) {}
  }

  function finish() { busy = false; save(); render(); }

  var bagCount = -1;
  function paintBag(n, hop) {
    views.forEach(function (v) {
      (v.bags || []).forEach(function (el) {
        el.hidden = !n;
        el.querySelector('b').textContent = n > 99 ? '99+' : String(n || '');
        el.setAttribute('aria-label', n ? 'Your bag, ' + n + (n === 1 ? ' item' : ' items') : 'Your bag');
        if (hop && n) { el.classList.remove('is-hop'); void el.offsetWidth; el.classList.add('is-hop'); }
      });
    });
    bagCount = n;
  }
  function readBag(hop) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { paintBag(c.item_count || 0, hop && (c.item_count || 0) > bagCount); return c; })
      .catch(function () {});
  }

  /* A pre-order carries its promise into the bag and on to the order, word for word as the product page sends it
     (theme.js addToCart: key = the locale's "Pre-order", value = "Ships <date>" or the product's own note). */
  function preorderLine(line, item) {
    if (item.preorder) { line.properties = {}; line.properties[(window.MagicStore && MagicStore.strings && MagicStore.strings.preorderKey) || 'Pre-order'] = item.preorder; }
    return line;
  }

  /* Add one of a version to the bag: Shopify's own cart, in the shopper's currency. */
  function addToBag(item) {
    busy = true; render();
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [preorderLine({ id: Number(item.variant_id), quantity: 1 }, item)] }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          thread.push({ role: 'pip', text: 'I couldn’t add that one: ' + (res.j && (res.j.description || res.j.message) || 'it may have just sold out') + '.', flag: 'error', local: true });
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        readBag(true);
        thread.push({ role: 'pip', text: 'Anything else?', cards: { added: item, replies: ['Keep shopping', 'Check out now'] } });
        logBag('add', item);
        setTimeout(gapAfterAdd, 400);
      })
      .catch(function () { thread.push({ role: 'pip', text: 'Sorry, I couldn’t reach the bag just now. Please try again.', flag: 'error', local: true }); })
      .then(finish);
  }

  /* Save for later: the store's own save button does it (the same list as the bookmark on product pages; signed
     out, it takes the shopper to sign in and saves when they come back). */
  function saveForLater(item) {
    var list = [];
    try { list = JSON.parse(localStorage.getItem('magicstore:saves') || '[]') || []; } catch (e) {}
    var already = list.some(function (x) { return x.handle === item.handle; });
    if (!already) {
      var b = document.createElement('button');
      b.type = 'button'; b.hidden = true;
      b.setAttribute('data-save', item.handle);
      b.setAttribute('data-product-id', item.product_id || '');
      b.setAttribute('data-variant-id', item.variant_id || '');
      b.setAttribute('data-title', item.title || '');
      b.setAttribute('data-url', item.url || '');
      b.setAttribute('data-image', item.image || '');
      b.setAttribute('data-price', item.price || '');
      if (item.cents != null) b.setAttribute('data-price-cents', String(item.cents));
      document.body.appendChild(b);
      b.click();
      b.remove();
    }
    // signed out, the store's save button has just sent them to sign in; the save is made when they're back
    var later = !already && !cfg.signedIn;
    thread.push({ role: 'pip', text: '', cards: { saved: { title: item.title, image: item.image, already: already, later: later } } });
    if (!already && !later) logBag('save', item);
    save(); render();
  }

  /* Free shipping is $75 USD for Canada and the USA, shown in the shopper's currency the way the site banner does
     (the rate Shopify gives the page, rounded up: $109 CAD). Nothing to ship, or another country: no line. */
  function freeShip(cart) {
    var country = (window.Shopify && Shopify.country) || cfg.country || '';
    if (!cart.requires_shipping || (country && country !== 'CA' && country !== 'US')) return null;
    var rate = Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    var at = (cart.currency === 'USD' ? 75 : Math.ceil(75 * rate)) * 100;
    // only what ships counts: free shipping is a rate on the shipment, so downloads and streams don't move it
    var ships = (cart.items || []).reduce(function (t, i) { return t + (i.requires_shipping ? (i.final_line_price || 0) : 0); }, 0);
    var left = at - ships;
    return left <= 0 ? { free: true, text: 'Free shipping applies' }
                     : { free: false, gap: left, at: at, text: money(left, cart.currency) + ' away from free shipping' };
  }

  var BAG_GAP = ENDPOINT.replace(/\/chat$/, '/gapfill');
  function gapWorth(ship) { return ship && !ship.free && ship.gap > 0 && ship.gap <= ship.at * 0.4; }
  function fetchFill(cart, ship) {
    var country = (window.Shopify && Shopify.country) || cfg.country || '';
    var handles = (cart.items || []).map(function (i) { return i.handle; }).filter(Boolean).slice(0, 10).join(',');
    return fetch(BAG_GAP + '?gap=' + ship.gap + '&country=' + encodeURIComponent(country) + '&handles=' + encodeURIComponent(handles),
                 { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .then(function (d) { return (d && d.items) || []; }, function () { return []; });
  }
  function gapLine(ship, fill) {
    return 'You’re ' + money(ship.gap, ship.cur) + ' away from free shipping. Want to add ' +
      (fill[0] && fill[0].why === 'deck' ? 'a deck' : 'something') + ' to get there?';
  }
  /* Once after an add (not every turn): the gap, and 2-3 things that close it. */
  function gapAfterAdd() {
    try { if (sessionStorage.getItem('tms:pip:gapshown')) return; } catch (e) {}
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var ship = freeShip(cart);
      if (!gapWorth(ship)) return;
      ship.cur = cart.currency;
      return fetchFill(cart, ship).then(function (fill) {
        if (!fill.length) return;
        try { sessionStorage.setItem('tms:pip:gapshown', '1'); } catch (e) {}
        // Check out now stays right there: the gap message carries the same two buttons
        thread.push({ role: 'pip', text: gapLine(ship, fill), cards: { gapfill: fill, replies: ['Keep shopping', 'Check out now'] }, local: true });
        save(); render();
      });
    }).catch(function () {});
  }
  function lastFill() {
    for (var i = thread.length - 1; i >= 0; i--) {
      var c = thread[i].cards || {};
      if (c.gapfill) return c.gapfill;
      if (c.checkout && c.checkout.fill) return c.checkout.fill;
    }
    return null;
  }
  function fillHtml(fill, line) {
    if (!fill || !fill.length) return '';
    return '<div class="pchat-gap">' + (line ? '<p>' + esc(line) + '</p>' : '') + fill.map(function (f, i) {
      return '<div class="pchat-gaprow">' + (f.image ? '<img src="' + esc(img(f.image, 80)) + '" alt="">' : '<span class="pchat-noimg"></span>') +
        '<a href="' + esc(f.url) + '"><b>' + esc(f.title) + '</b><small>' + esc(f.price) + '</small></a>' +
        '<button type="button" data-pip-gapadd="' + i + '">Add</button></div>';
    }).join('') + '</div>';
  }

  /* The bag total and the way out: /cart.js is the bag as Shopify has it, in the shopper's currency. */
  function showCheckout(m) {
    busy = true; render();
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (cart) {
        var sum = { count: cart.item_count || 0, total: cart.total_price || 0, currency: cart.currency || '',
          lines: (cart.items || []).map(function (i) {
            var pre = '';
            for (var key in (i.properties || {})) if (/^pre-?order$/i.test(key)) pre = i.properties[key];
            return { title: i.product_title || i.title, version: i.product_has_only_default_variant ? '' : (i.variant_title || ''),
                     qty: i.quantity, price: i.final_line_price, image: i.image || '', pre: pre };
          }),
          codes: (cart.cart_level_discount_applications || []).map(function (d) {
            return { title: (d.type === 'discount_code' ? 'Code ' : '') + d.title, amount: d.total_allocated_amount || 0 };
          }) };
        sum.ship = freeShip(cart);
        if (gapWorth(sum.ship)) {
          sum.ship.cur = cart.currency;
          return fetchFill(cart, sum.ship).then(function (fill) {
            if (fill.length) { sum.fill = fill; sum.gapText = gapLine(sum.ship, fill); }
            return sum;
          });
        }
        return sum;
      })
      .then(function (sum) {
        if (m) { m.cards.checkout = sum; } else { thread.push({ role: 'pip', text: '', cards: { checkout: sum }, local: true }); }
        logBag('checkout', { price: money(sum.total, sum.currency) });
      })
      .catch(function () { thread.push({ role: 'pip', text: 'Sorry, I couldn’t open the bag just now. [View bag](/cart)', flag: 'error', local: true }); })
      .then(finish);
  }

  /* Suggested replies sit under Pip's bubble, one per line on the reader's
     side, not wrapped inside the bubble (Rich, 10-05: "badly positioned"). */
  function repliesHtml(c, last) {
    if (!c || !last) return '';
    var hasClaim = (c.offers || []).some(function (o) { return o.claimable && !o.code && claimedIds().indexOf(o.id) < 0; });
    var replies = (c.replies || []).filter(function (r) { return !(hasClaim && /^claim it$/i.test(r)); });
    if (!replies.length) return '';
    return '<div class="pchat-replies">' + replies.map(function (r) {
      return '<button type="button" data-pchat-reply="' + esc(r) + '">' + esc(r) + '</button>';
    }).join('') + '</div>';
  }

  function msgHtml(m, last) {
    if (m.role === 'user') return '<div class="pchat-me">' + esc(m.text) + '</div>';
    if (m.role === 'team') {
      return '<p class="pchat-who is-team"><i></i>' + esc(m.by || TEAM) + ' · from the store</p><div class="pchat-team">' + fmt(m.text) + '</div>' +
        (last && talkingTo() ? '<p class="pchat-note">Your next message goes to ' + esc(m.by || TEAM) + '. <button type="button" data-pip-unteam>Ask Pip instead</button></p>' : '');
    }
    if (m.role === 'note') return '<p class="pchat-note">' + esc(m.text) + (m.team && last && talkingTo() ? ' <button type="button" data-pip-unteam>Ask Pip instead</button>' : '') + '</p>';
    return '<p class="pchat-who">Pip</p><div class="pchat-pip' + (m.flag ? ' is-' + m.flag : '') + '">' +
      bagHtml(m.cards, last) + fmt(m.text) + (m.cards && m.cards.gapfill ? fillHtml(m.cards.gapfill, '') : '') + cardsHtml(m.cards, last) +
      (m.handed ? '<p class="pchat-sent">Sent to the store</p>' : '') + '</div>' +
      (m.cards && m.cards.bag && !m.cards.bag.done ? offerHtml(m.cards, last) : repliesHtml(m.cards, last));
  }

  /* Top of every chat: questions are kept to train Pip (tms-backend
     pip_questions.py, since 10-12), so say so before the first message. */
  var LEGAL = '<p class="pchat-legal">Chats with Pip are saved so we can help you and make Pip better. ' +
    'By chatting, you agree to our <a href="/policies/privacy-policy">Privacy Policy</a> and ' +
    '<a href="/policies/terms-of-service">Terms of&nbsp;Service</a>.</p>';

  /* Only messages that changed are redrawn, so images already on screen
     don't flicker every time Pip answers. */
  function render() {
    views.forEach(function (v) {
      if (v.gate && v.gate.parentNode === v.thread) return;   // the guest step is showing (11-02)
      var reopened = !v.cache || !v.cache.length;
      if (!v.cache) { v.cache = []; v.thread.innerHTML = LEGAL + (v.context ? '<p class="pchat-ctx">' + esc(v.context) + '</p>' : ''); }
      var html = thread.map(function (m, i) { return msgHtml(m, i === thread.length - 1); });
      var keep = 0;
      while (keep < html.length && keep < v.cache.length && html[keep] === v.cache[keep]) keep++;
      [].slice.call(v.thread.querySelectorAll('.pchat-msg')).forEach(function (el, i) { if (i >= keep) el.remove(); });
      var typing = v.thread.querySelector('.pchat-busy');
      if (typing) typing.remove();
      var firstNewPip = null;
      for (var i = keep; i < html.length; i++) {
        var el = document.createElement('div');
        el.className = 'pchat-msg ' + (thread[i].role === 'user' ? 'is-me' : 'is-pip');
        el.innerHTML = html[i];
        v.thread.appendChild(el);
        if (!firstNewPip && thread[i].role !== 'user') firstNewPip = el;
      }
      v.cache = html;
      if (busy) {
        var t = document.createElement('div');
        t.className = 'pchat-msg is-pip pchat-busy';
        t.innerHTML = '<p class="pchat-who">Pip</p><div class="pchat-pip pchat-typing" aria-label="Pip is typing"><i></i><i></i><i></i></div>' +
          (slow ? '<p class="pchat-slow" role="status">Still thinking…</p>' : '');
        v.thread.appendChild(t);
      }
      /* Rich, 10-08: a long answer used to land scrolled to its end. When Pip answers, the question
         goes to the top of the chat and the answer reads down from it; a short answer just ends up
         at the bottom as before (the browser stops the scroll at the end). */
      var anchor = firstNewPip && !busy && !reopened ? firstNewPip : null;
      if (anchor) {
        var prev = anchor.previousElementSibling;
        if (prev && prev.classList.contains('is-me')) anchor = prev;
        var top = anchor.getBoundingClientRect().top - v.thread.getBoundingClientRect().top + v.thread.scrollTop - 8;
        v.thread.scrollTop = Math.max(0, top);
      } else if (keep < html.length || busy || reopened) {
        v.thread.scrollTop = v.thread.scrollHeight;   // something new (or the typing dots) at the end
      }                                                // nothing new: leave the reader where they are
      if (v.send) v.send.disabled = busy;
      v.orbs.forEach(function (o) { o.setAttribute('data-state', busy ? 'thinking' : ''); });
    });
  }

  function found() {
    views.forEach(function (v) {
      v.orbs.forEach(function (o) {
        o.setAttribute('data-state', 'found');
        setTimeout(function () { if (o.getAttribute('data-state') === 'found') o.setAttribute('data-state', ''); }, 1400);
      });
    });
  }

  function getPass() {
    try { var p = JSON.parse(localStorage.getItem(PASS_KEY) || 'null'); return p && p.pass ? p : null; }
    catch (e) { return null; }
  }
  function gated() { return !cfg.signedIn && !getPass(); }

  function post(body) {
    body.browser = browserId();
    if (!cfg.signedIn) body.pass = (getPass() || {}).pass || '';
    if (cfg.product && cfg.product.handle) body.looking_at = cfg.product.handle;
    if (cfg.creator) body.creator = cfg.creator;  // on a creator's link page
    body.recent = recentList().filter(function (h) { return h !== body.looking_at; }).slice(0, 8);
    // The shopper's store currency setting, so Pip quotes their market's prices (CAD in Canada). Shopify's
    // own values first; the page's server-rendered market (PipConfig) when a page lacks them (10-08: a
    // turn without a country came back in USD for a shopper in Canada).
    var shop = window.Shopify || {}, cur = shop.currency || {};
    if (shop.country || cfg.country) body.country = shop.country || cfg.country;
    if (cur.active || cfg.currency) body.currency = cur.active || cfg.currency;
    if (cur.active && cur.rate) body.rate = cur.rate;
    // The answer is a job (10-08): this request only starts it, and poll() fetches it. A dropped line,
    // a phone that sleeps the tab or a page change then costs a poll, never the answer. The same rid on
    // a retry gets the same job back, so a retry never asks Pip twice.
    if (body.messages.length) { body.job = 1; body.rid = body.rid || 'r' + Math.random().toString(36).slice(2) + Date.now().toString(36); }
    var attempt = function (n) {
      return getJson(ENDPOINT, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }, 25000).catch(function (e) {
        if (n >= 2) throw e;          // tried, retried, then "Still thinking…" and once more
        if (n === 1) thinking();
        return wait(n ? 3000 : 800).then(function () { return attempt(n + 1); });
      });
    };
    return attempt(0).then(function (d) { return d && d.job ? poll(d.job, body) : d; });
  }

  /* fetch with a time limit, so a stalled line fails (and is retried) instead of hanging.
     Anything but JSON - Shopify's HTML error page - counts as a failure too. */
  var inflight = null;
  function getJson(url, opts, ms) {
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, ms) : 0;
    if (ctl) { opts.signal = ctl.signal; inflight = { ctl: ctl, at: Date.now() }; }
    var end = function () { clearTimeout(timer); if (inflight && inflight.ctl === ctl) inflight = null; };
    return fetch(url, opts).then(function (r) {
      if (!r.ok) throw new Error('status ' + r.status);
      return r.json();
    }).then(function (d) { end(); return d; }, function (e) { end(); throw e; });
  }

  /* A pause that ends early when the tab comes back into view: a phone pauses timers on a
     hidden tab, so the answer is fetched the moment the shopper looks again. */
  var wake = null;
  function wait(ms) {
    return new Promise(function (done) {
      var t, go = function () { clearTimeout(t); if (wake === go) wake = null; done(); };
      t = setTimeout(go, ms); wake = go;
    });
  }
  // Back in view: a request the hidden tab left hanging is dropped and asked again at once (same job).
  var back = function () {
    if (inflight && Date.now() - inflight.at > 3000) inflight.ctl.abort();
    if (wake) wake();
  };
  document.addEventListener('visibilitychange', function () { if (!document.hidden) back(); });
  window.addEventListener('pageshow', back);

  function thinking() { if (!slow) { slow = true; render(); } }

  function poll(job, body) {
    try { sessionStorage.setItem(PENDING_KEY, JSON.stringify({ job: job, at: Date.now() })); } catch (e) {}
    var started = Date.now(), misses = 0;
    var url = ENDPOINT + '?job=' + encodeURIComponent(job) + '&browser=' + encodeURIComponent(browserId());
    var next = function (ms) {
      return wait(ms).then(function () {
        return getJson(url, { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } }, 10000)
          .then(function (d) {
            misses = 0;
            if (d && d.pending) {
              if (Date.now() - started > 12000) thinking();
              if (Date.now() - started > 150000) throw new Error('too long');
              return next(1000);
            }
            // The server lost it (a restart mid-answer): ask once more, as a new job.
            if (d && d.gone && body && !body.again) {
              thinking();
              body.again = 1; body.rid = '';
              return post(body);
            }
            if (d && d.gone) throw new Error('gone');
            return d;
          }, function (e) {
            misses++; thinking();
            if (Date.now() - started > 150000) throw e;
            return next(Math.min(1000 * misses, 4000));
          });
      });
    };
    return next(1200).then(function (d) { forget(job); return d; }, function (e) { forget(job); throw e; });
  }

  function forget(job) {
    try {
      var p = JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null');
      if (!p || p.job === job) sessionStorage.removeItem(PENDING_KEY);
    } catch (e) {}
  }

  function receive(d) {
    var flag = d.off ? 'off' : d.limited ? 'limited' : d.error ? 'error' : '';
    var m = { role: 'pip', text: d.reply || '', cards: d.cards || null, handed: !!d.handed_off, flag: flag, local: !!flag };
    thread.push(m);
    var c = d.cards || {};
    // the shopper said yes in words: their browser does the add (Rich 10-08)
    if (c.bag_add) { var add = c.bag_add; delete c.bag_add; setTimeout(function () { addToBag(add); }, 0); }
    if (c.bag_save) { var sv = c.bag_save; delete c.bag_save; setTimeout(function () { saveForLater(sv); }, 0); }
    if (c.checkout === true) { delete c.checkout; setTimeout(function () { showCheckout(m); }, 0); }
  }

  function fail() {
    thread.push({ role: 'pip', text: 'Sorry, I couldn’t connect just now. Please try again.', flag: 'error', local: true });
  }

  function run(body) {
    busy = true; slow = false; save(); render();
    return post(body).then(function (d) {
      if (d && d.gate) return regate();
      receive(d);
    }, fail).then(function () {
      busy = false; slow = false; save(); render(); found();
    });
  }

  /* The pass was refused (expired, or a new device): take the question back and show the form. */
  function regate() {
    try { localStorage.removeItem(PASS_KEY); } catch (e) {}
    var last = thread[thread.length - 1];
    if (last && last.role === 'user') { waiting = last.text; thread.pop(); }
    showGate(true);
  }

  /* A page change while Pip was answering: pick the same answer up here. */
  function pickUp() {
    var p = null;
    try { p = JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null'); } catch (e) {}
    if (!p || !p.job || busy) return;
    if (Date.now() - (p.at || 0) > 150000) { forget(p.job); return; }
    busy = true; slow = false; render();
    poll(p.job, null).then(receive, fail).then(function () {
      busy = false; slow = false; save(); render(); found();
    });
  }

  function send(text) {
    text = String(text || '').trim().slice(0, 800);
    if (!text || busy) return;
    if (gated()) { waiting = text; showGate(true); return; }
    var to = talkingTo();
    if (to) { toPerson(to, text); return; }
    thread.push({ role: 'user', text: text });
    var messages = thread.filter(function (m) { return !m.local; }).map(function (m) {
      var out = { role: m.role === 'pip' ? 'assistant' : 'user', text: m.text };
      var c = m.cards || {};
      var shown = (c.products || []).map(function (p) { return p.title; })
        .concat((c.book_pages || []).map(function (b) { return (b.entry ? b.entry + ' in ' : '') + b.title + ', page ' + b.page; }))
        .concat((c.offers || []).map(function (o) { return 'Offer: ' + o.title; }))
        .concat((c.games || []).map(function (g) { return 'Game: ' + g.name; }))
        .concat((c.instructions || []).map(function (x) { return 'Instructions card: ' + x.title; }))
        .concat(c.added ? ['Added to bag: ' + c.added.title + (c.added.version ? ' (' + c.added.version + ')' : '') + ', ' + c.added.price + (c.added.preorder ? ' (pre-order: ' + c.added.preorder + ')' : '')] : [])
        .concat(c.saved ? ['Saved for later: ' + c.saved.title] : [])
        .concat(c.bag && !c.added ? ['Offered to add to bag: ' + c.bag.title + ' (buttons: Add to bag / Save for later)'] : []);
      if (m.role === 'pip' && shown.length) out.shown = shown.slice(0, 8);
      return out;
    });
    run({ messages: messages });
  }

  function greet() {
    if (gated()) { showGate(true); return; }
    if (thread.length || busy) { render(); return; }
    run({ messages: [] });
  }

  function claim(id) {
    if (busy) return;
    if (gated()) { showGate(true); return; }
    run({ messages: [], claim: id });
  }

  function reset() {
    thread = []; save();
    views.forEach(function (v) { v.cache = null; });
    greet();
  }

  /* Sign in and come straight back to the chat. This store uses Shopify's new
     customer accounts, which ignore return_url; /customer_authentication/login
     honours return_to (same as snippets/login-url.liquid). The last question is
     kept so Pip can answer it again once he can see their orders. */
  function signIn() {
    var last = '';
    for (var i = thread.length - 1; i >= 0; i--) if (thread[i].role === 'user') { last = thread[i].text; break; }
    try { sessionStorage.setItem(OPEN_KEY, '1'); if (last) sessionStorage.setItem(RESUME_KEY, last); } catch (e) {}
    var base = cfg.loginUrl || '/account/login';
    location.href = base.indexOf('customer_authentication') > -1
      ? '/customer_authentication/login?return_to=' + encodeURIComponent(here())
      : base + (base.indexOf('?') > -1 ? '&' : '?') + 'return_url=' + encodeURIComponent(here());
  }

  /* Back from signing in: say so, and ask the waiting question again. */
  function resume() {
    if (!cfg.signedIn) return;
    var q = '';
    try { q = sessionStorage.getItem(RESUME_KEY) || ''; sessionStorage.removeItem(RESUME_KEY); } catch (e) {}
    if (!q) return;
    var go = function () {
      if (busy) { setTimeout(go, 400); return; }
      thread.push({ role: 'pip', text: 'You’re signed in. Let me look again.', local: true });
      send(q);
    };
    go();
  }

  function play(url) {
    if (url.charAt(0) === '?') {
      if (window.msOpenFtl) { window.msOpenFtl(); return; }
      location.href = location.pathname + url;
      return;
    }
    location.href = url;
  }

  /* Apply puts the code on their session (Shopify's /discount/ route), then lands
     somewhere that makes sense: the bag if there's something in it, otherwise keep
     shopping - the page they were on, or the home page if they were on Ask Pip. */
  function applyCode(base) {
    var go = function (to) { location.href = base + '?redirect=' + encodeURIComponent(to); };
    var onPip = location.pathname.indexOf(PAGE) === 0 || !!document.querySelector('[data-apip]');
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      go(c && c.item_count > 0 ? '/cart' : onPip ? '/' : location.pathname + location.search);
    }, function () { go('/cart'); });
  }

  function lastGame() {
    for (var i = thread.length - 1; i >= 0; i--) {
      var g = thread[i].cards && thread[i].cards.games;
      if (g && g.length) return g[0].url;
    }
    return '';
  }

  function lastClaimable() {
    for (var i = thread.length - 1; i >= 0; i--) {
      var o = thread[i].cards && thread[i].cards.offers;
      if (o) for (var j = 0; j < o.length; j++) if (o[j].claimable) return o[j].id;
    }
    return '';
  }

  /* ------------------------------------------------------------ the guest step (11-02) */
  var waiting = '';   // a question asked before the form was filled, sent once it is
  /* Rich, 11-02: no separate screen. The step is Pip's first message: his bubble asks who he's
     chatting with, the form is a card inside it (like his offer cards), Sign in is a reply, and
     the chat box stays open; a question typed first waits under the form until it's filled in. */
  var GATE = '<form class="pchat-msg is-pip pgate" data-pgate novalidate>' +
    '<p class="pchat-who">Pip</p>' +
    '<div class="pchat-pip">' +
      '<p>Hi, I’m Pip, your AI Magic Genie. Before we start, tell me a little about you, so I know who I’m chatting&nbsp;with.</p>' +
      '<div class="pgate__f">' +
        '<label class="visually-hidden" for="IDn">First name</label>' +
        '<input id="IDn" name="name" type="text" placeholder="First name" autocomplete="given-name" maxlength="60" required>' +
        '<label class="visually-hidden" for="IDe">Email</label>' +
        '<input id="IDe" name="email" type="email" placeholder="Email" autocomplete="email" maxlength="254" required>' +
        '<div class="pgate__trap" aria-hidden="true"><input name="website" type="text" tabindex="-1" autocomplete="off"></div>' +
        '<label class="pgate__tick"><input name="terms" type="checkbox" required><span>I agree to the ' +
          '<a href="/policies/terms-of-service" target="_blank">Terms of Service</a> and ' +
          '<a href="/policies/privacy-policy" target="_blank">Privacy&nbsp;Policy</a>.</span></label>' +
        '<label class="pgate__tick"><input name="news" type="checkbox"><span>Email me new tricks and offers. Optional, unsubscribe any&nbsp;time.</span></label>' +
        '<p class="pgate__err" role="alert" hidden></p>' +
        '<button class="pgate__go" type="submit" disabled>Let’s chat</button>' +
      '</div>' +
    '</div>' +
    '<div class="pchat-replies"><button type="button" data-pgate-in>I have an account, sign me in</button></div>' +
    '<div class="pgate__later" data-pgate-later></div>' +
  '</form>';

  function showGate(on) {
    views.forEach(function (v) {
      if (!v.gate) return;
      v.root.classList.toggle('is-gated', on);
      if (on) {
        if (v.gate.parentNode !== v.thread) { v.thread.innerHTML = ''; v.thread.appendChild(v.gate); }
        if (!v.gateAt) v.gateAt = Date.now();
        var later = v.gate.querySelector('[data-pgate-later]');
        later.innerHTML = waiting ? '<div class="pchat-msg is-me"><div class="pchat-me">' + esc(waiting) + '</div></div>' +
          '<div class="pchat-msg is-pip"><div class="pchat-pip"><p>Good question. I’ll answer it as soon as you’ve filled that&nbsp;in.</p></div></div>' : '';
        v.thread.scrollTop = waiting ? v.thread.scrollHeight : 0;
      } else if (v.gate.parentNode) {
        v.gate.parentNode.removeChild(v.gate);
        v.cache = null;
      }
    });
  }

  function hello(v) {
    var f = v.gate, err = f.querySelector('.pgate__err'), go = f.querySelector('.pgate__go');
    var val = function (n) { return f.elements[n].value.trim(); };
    var say = function (t) { err.textContent = t; err.hidden = !t; };
    if (!val('name')) return say('Please add your first name.');
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(val('email'))) return say('Please check your email.');
    if (!f.elements.terms.checked) return say('Please tick the box to agree first.');
    say(''); go.disabled = true;
    getJson(HELLO, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ name: val('name'), email: val('email'), terms: true, news: f.elements.news.checked,
                             website: f.elements.website.value, secs: Math.round((Date.now() - (v.gateAt || 0)) / 1000),
                             browser: browserId() })
    }, 15000).then(function (d) {
      go.disabled = !f.elements.terms.checked;
      if (!d || !d.ok) return say((d && d.error) || 'Sorry, that didn’t work. Please try again.');
      try { localStorage.setItem(PASS_KEY, JSON.stringify({ pass: d.pass, name: d.name || '' })); } catch (e) {}
      showGate(false);
      views.forEach(function (x) { x.cache = null; });
      var q = waiting; waiting = '';
      if (q) send(q); else greet();
      if (v.input && !window.matchMedia('(max-width: 599px)').matches) v.input.focus();
    }, function () { go.disabled = !f.elements.terms.checked; say('Sorry, I couldn’t connect. Please try again.'); });
  }

  /* One view = a thread element, a form, and the orbs that react. */
  function mount(root, opts) {
    var v = {
      root: root,
      thread: root.querySelector('[data-pchat-thread]'),
      form: root.querySelector('[data-pchat-form]'),
      orbs: [].slice.call(root.querySelectorAll('[data-pchat-orb]')),
      context: (opts && opts.context) || ''
    };
    v.bags = v.orbs.map(function (o) {
      var wrap = document.createElement('span');
      wrap.className = 'pip-holds';
      o.parentNode.insertBefore(wrap, o);
      wrap.appendChild(o);
      var bagEl = document.createElement('button');
      bagEl.type = 'button';
      bagEl.className = 'pip-bag';
      bagEl.hidden = true;
      bagEl.setAttribute('data-pip-bag', '');
      bagEl.setAttribute('aria-label', 'Your bag');
      bagEl.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M6.2 7V5.6a3.8 3.8 0 017.6 0V7" fill="none" stroke="#0058B0" stroke-width="1.8" stroke-linecap="round"/>' +
        '<path d="M3.6 7h12.8l-1 10.2a1.2 1.2 0 01-1.2 1.1H5.8a1.2 1.2 0 01-1.2-1.1z" fill="#0071E3"/></svg><b></b>';
      wrap.appendChild(bagEl);
      return bagEl;
    });
    if (!cfg.signedIn && v.thread) {
      var holder = document.createElement('div');
      holder.innerHTML = GATE.replace(/ID([ne])/g, 'pgate' + views.length + '$1');
      v.gate = holder.firstChild;
      v.gate.addEventListener('submit', function (e) { e.preventDefault(); hello(v); });
      v.gate.querySelector('[data-pgate-in]').addEventListener('click', signIn);
      var go = v.gate.querySelector('.pgate__go');
      v.gate.elements.terms.addEventListener('change', function () { go.disabled = !this.checked; });
    }
    v.input = v.form && v.form.querySelector('input, textarea');
    v.send = v.form && v.form.querySelector('[type="submit"]');
    if (v.form) v.form.addEventListener('submit', function (e) {
      e.preventDefault();
      var t = v.input.value; v.input.value = ''; send(t);
    });
    root.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-pip-bag]')) {
        if (busy) return;
        thread.push({ role: 'user', text: 'My bag', local: true });
        return showCheckout(null);
      }
      var t = e.target.closest && e.target.closest('[data-pchat-reply],[data-pchat-claim],[data-pchat-game],[data-pchat-apply],[data-pchat-copy],[data-pip-add],[data-pip-save],[data-pip-gapadd]');
      if (!t) return;
      if (t.hasAttribute('data-pip-gapadd')) {
        if (busy) return;
        var fl = lastFill(), f = fl && fl[Number(t.getAttribute('data-pip-gapadd'))];
        if (!f) return;
        try { sessionStorage.setItem('tms:pip:gapshown', '1'); } catch (e) {}
        t.disabled = true;
        thread.push({ role: 'user', text: 'Add ' + f.title });
        save(); render();
        return addToBag({ handle: f.handle, product_id: f.product_id, title: f.title, url: f.url, image: f.image,
                          variant_id: f.variant_id, version: '', price: f.price });
      }
      if (t.hasAttribute('data-pip-add') || t.hasAttribute('data-pip-save')) {
        if (busy) return;
        var lb = lastBag();
        if (!lb) return;
        var bag = lb.cards.bag;
        bag.done = true;                        // the buttons go once used
        if (t.hasAttribute('data-pip-save')) {
          thread.push({ role: 'user', text: 'Save for later' });
          var o0 = (bag.options || []).filter(function (o) { return o.available; })[0] || (bag.options || [])[0] || {};
          return saveForLater({ handle: bag.handle, product_id: bag.product_id, title: bag.title, url: bag.url, image: bag.image,
                                variant_id: o0.variant_id, price: o0.price, cents: o0.cents });
        }
        var o = (bag.options || [])[Number(t.getAttribute('data-pip-add'))];
        if (!o || !o.available) return;
        thread.push({ role: 'user', text: t.textContent });
        save(); render();
        return addToBag({ handle: o.handle || bag.handle, product_id: o.product_id || bag.product_id, title: o.title || bag.title,
                          url: o.url || bag.url, image: o.image || bag.image, variant_id: o.variant_id,
                          version: o.version, price: o.price, preorder: o.preorder || '' });   // "Imprint (Streaming)"
      }
      if (t.hasAttribute('data-pchat-copy')) {
        var done = function () { t.textContent = 'Copied'; setTimeout(function () { t.textContent = 'Copy password'; }, 1600); };
        if (navigator.clipboard) navigator.clipboard.writeText(t.getAttribute('data-pchat-copy')).then(done, done); else done();
        return;
      }
      if (t.hasAttribute('data-pchat-apply')) { e.preventDefault(); return applyCode(t.getAttribute('data-base')); }
      if (t.hasAttribute('data-pchat-claim')) return claim(t.getAttribute('data-pchat-claim'));
      if (t.hasAttribute('data-pchat-game')) return play(t.getAttribute('data-pchat-game'));
      var r = t.getAttribute('data-pchat-reply');
      var lastM = thread[thread.length - 1];
      if (lastM && lastM.cards && (lastM.cards.added || lastM.cards.gapfill) && /^(keep shopping|check out now)$/i.test(r)) {
        lastM.cards.replies = [];
        thread.push({ role: 'user', text: r, local: true });
        if (/^check out now$/i.test(r)) return showCheckout(null);
        thread.push({ role: 'pip', text: 'Sure. What else can I find for you?', local: true });
        save(); render();
        if (v.input) v.input.focus();
        return;
      }
      if (/^sign ?in$/i.test(r) && !cfg.signedIn) return signIn();
      if (/^play\b/i.test(r) && lastGame()) return play(lastGame());
      if (/^claim it$/i.test(r) && lastClaimable() && claimedIds().indexOf(lastClaimable()) < 0) return claim(lastClaimable());
      send(r);
    });
    views.push(v);
    readBag(false);
    return v;
  }

  /* ------------------------------------------------------------ replies from the store (11-02)
     A person at the store answered a chat Pip handed over. The reply waits on the server for this
     shopper (signed-in account, else this browser's id). Asked when a page loads (at most every
     few minutes) and whenever the chat opens; shown as a message from James; the Pip button gets
     a red count while one is unread. Their next message goes to James, not Pip, until they tap
     "Ask Pip instead" or a day goes by. */
  function talkingTo() {
    try {
      var t = JSON.parse(localStorage.getItem(TO_KEY) || 'null');
      if (t && t.handoff && t.until > Date.now()) return t.handoff;
    } catch (e) {}
    return '';
  }
  function setTalkingTo(h) {
    try { if (h) localStorage.setItem(TO_KEY, JSON.stringify({ handoff: h, until: Date.now() + 864e5 })); else localStorage.removeItem(TO_KEY); } catch (e) {}
  }
  var unread = [];
  function badge() {
    var n = unread.length;
    [].forEach.call(document.querySelectorAll('[data-pipw-open]'), function (b) {
      var c = b.querySelector('.pipw-count');
      if (!n) { if (c) c.remove(); b.classList.remove('has-reply'); return; }
      if (!c) { c = document.createElement('i'); c.className = 'pipw-count'; b.appendChild(c); }
      c.textContent = n; b.classList.add('has-reply');
      b.setAttribute('aria-label', 'Ask Pip: ' + n + (n === 1 ? ' reply' : ' replies') + ' from the store');
    });
    var peek = document.querySelector('[data-pipw-peek]');
    if (peek) {
      peek.hidden = !n || !chatClosed();
      if (n) peek.querySelector('span').textContent = unread[unread.length - 1].text.slice(0, 90);
    }
  }
  function chatClosed() { var p = document.querySelector('[data-pipw-panel]'); return !views.some(function (v) { return v.root && v.root.offsetParent; }) && (!p || p.hidden); }
  function checkInbox(force) {
    var last = 0;
    try { last = +localStorage.getItem(INBOX_AT) || 0; } catch (e) {}
    if (!force && Date.now() - last < 180000) return;
    try { localStorage.setItem(INBOX_AT, String(Date.now())); } catch (e) {}
    fetch(INBOX + '?browser=' + encodeURIComponent(browserId()), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.replies || !d.replies.length) return;
        var have = {};
        thread.forEach(function (m) { if (m.rid) have[m.rid] = true; });
        d.replies.forEach(function (r) {
          if (have[r.id]) return;
          thread.push({ role: 'team', text: r.text, by: r.by, rid: r.id, local: true });
          unread.push(r);
        });
        if (d.thread) setTalkingTo(d.thread);
        save(); render(); badge();
        if (!chatClosed()) markSeen();
      }).catch(function () {});
  }
  function markSeen() {
    if (!unread.length) return;
    var ids = unread.map(function (r) { return r.id; });
    unread = []; badge();
    fetch(INBOX, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ seen: ids, browser: browserId() }) }).catch(function () {});
  }
  function toPerson(handoff, text) {
    thread.push({ role: 'user', text: text, local: true });
    busy = true; save(); render();
    fetch(INBOX, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ answer: text, handoff: handoff, browser: browserId() }) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.ok) thread.push({ role: 'note', team: true, text: d.reply || ('Sent to ' + TEAM + '. You’ll get the answer here and by email.'), local: true });
        else { setTalkingTo(''); thread.push({ role: 'pip', text: 'That conversation has closed, so I’ll take it from here. Ask me again?', local: true }); }
      })
      .catch(function () { thread.push({ role: 'pip', text: 'Sorry, that didn’t send. Please try again.', flag: 'error', local: true }); })
      .then(function () { busy = false; save(); render(); });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-pip-unteam]')) {
      setTalkingTo('');
      thread.push({ role: 'note', text: 'Back to Pip. Ask me anything.', local: true });
      save(); render();
    }
  });
  checkInbox(false);

  pickUp();
  document.addEventListener('cart:refresh', function () { setTimeout(function () { readBag(true); }, 600); });

  window.PipChat = { mount: mount, send: send, greet: greet, reset: reset, render: render, page: PAGE, resume: resume,
    wantsOpen: function () {
      var w = false;
      try { w = sessionStorage.getItem(OPEN_KEY) === '1'; sessionStorage.removeItem(OPEN_KEY); } catch (e) {}
      return w || location.hash === '#pip' || /[?&]pip=open\b/.test(location.search);
    }
  };

  /* ------------------------------------------------------------ the widget */
  var w = document.querySelector('[data-pipw]');
  if (w) {
    var launch = w.querySelector('[data-pipw-open]');
    var panel = w.querySelector('[data-pipw-panel]');
    var ctx = cfg.product && cfg.product.title ? 'Looking at: ' + cfg.product.title : '';
    var wv = mount(panel, { context: ctx });
    var phone = window.matchMedia('(max-width: 599px)');
    var lastFocus = null;
    var open = function () {
      lastFocus = document.activeElement;
      panel.hidden = false; launch.hidden = true;
      w.classList.add('is-open');
      if (phone.matches) document.documentElement.classList.add('pipw-lock');
      greet();
      markSeen(); checkInbox(true);
      setTimeout(function () {
        if (phone.matches) return;
        var first = wv.gate && wv.gate.parentNode ? wv.gate.querySelector('input') : wv.input;
        if (first) first.focus();
      }, 60);
    };
    var close = function () {
      panel.hidden = true; launch.hidden = false; launch.classList.add('is-mini');
      w.classList.remove('is-open'); panel.classList.remove('is-full');
      document.documentElement.classList.remove('pipw-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    launch.addEventListener('click', open);
    var peek = document.createElement('button');
    peek.type = 'button'; peek.className = 'pipw-peek'; peek.hidden = true; peek.setAttribute('data-pipw-peek', '');
    peek.innerHTML = '<b>' + TEAM + ' from the store replied</b><span></span>';
    peek.addEventListener('click', open);
    w.appendChild(peek);
    badge();
    w.querySelector('[data-pipw-close]').addEventListener('click', close);
    /* On a phone the widget is already the better chat, so "full screen" grows
       the sheet to the whole screen (and back) rather than leaving for the Ask
       Pip page (Rich, 10-06). On a computer it still opens the page. */
    var fullBtn = w.querySelector('[data-pipw-full]');
    fullBtn.addEventListener('click', function () {
      if (!phone.matches) { location.href = PAGE + '?chat=1'; return; }
      var on = panel.classList.toggle('is-full');
      fullBtn.setAttribute('aria-label', on ? 'Exit full screen' : 'Open full screen');
      fullBtn.setAttribute('aria-pressed', String(on));
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#pip"],[data-pip-open]');
      if (a) { e.preventDefault(); open(); }
    });
    window.PipChat.open = open;

    /* Never sit on a phone buy bar (Add to bag, Pre-order) or the deck builder
       bar: while one is showing, the pill rises above it. Any other sticky
       bottom bar opts in with data-pip-avoid (the chair showroom's bar hid
       its Pre-order button under the pill, 2026-10-06). */
    var bars = function () { return [].slice.call(document.querySelectorAll('[data-buybar], [data-pip-avoid], .deckb__bar')); };
    var queued = false;
    var place = function () {
      queued = false;
      var lift = 0;
      bars().forEach(function (b) {
        if (b.hidden || getComputedStyle(b).visibility === 'hidden') return;   // stepped aside at the footer
        var r = b.getBoundingClientRect();
        if (r.height && r.top < innerHeight && r.bottom > innerHeight - 200) lift = Math.max(lift, innerHeight - r.top + 10);
      });
      launch.style.bottom = lift ? lift + 'px' : '';
      /* An in-page "Ask Pip" card (data-pip-dodge) under the orb already does
         his job, so he fades out while it's there instead of covering its
         button (Magician profile > Sets, 2026-10-11). Measured against his
         home corner, so tucking him away doesn't flip it back. */
      var bottom = innerHeight - (lift || 18), top = bottom - 64, left = innerWidth - 90, hit = false;
      [].forEach.call(document.querySelectorAll('[data-pip-dodge]'), function (el) {
        var r = el.getBoundingClientRect();
        if (r.height && r.top < bottom && r.bottom > top && r.right > left) hit = true;
      });
      launch.classList.toggle('is-dodged', hit);
    };
    var later = function () { if (!queued) { queued = true; requestAnimationFrame(place); } };
    addEventListener('scroll', later, { passive: true });
    addEventListener('resize', later, { passive: true });
    document.addEventListener('click', function () { setTimeout(later, 60); });  // tabs that swap in a dodge card
    /* The product buy card starts floating by a class on its slot, not on the
       bar, and then slides in; watching only the bar missed both, so Pip sat
       on Add to bag until the next scroll (Rich, 10-21). */
    bars().forEach(function (b) {
      new MutationObserver(later).observe(b, { attributes: true, childList: true, subtree: true });
      var slot = b.closest('[data-bbslot]');
      if (slot) new MutationObserver(later).observe(slot, { attributes: true, attributeFilter: ['class'] });
      b.addEventListener('transitionend', later);
    });

    /* On a phone Pip steps aside while the page is being read (Rich, 10-06):
       scrolling down slides him to the edge with only a sliver of his head
       showing, and he comes back the moment the reader scrolls up or stops.
       So he is never parked over a photo someone is trying to look at, and
       nobody has to know a gesture to move him. A tap on the sliver brings
       him back rather than opening the chat, because it may have been a
       miss for whatever was underneath. */
    var lastY = scrollY, idle = 0;
    var tuck = function (on) { launch.classList.toggle('is-tucked', on); };
    addEventListener('scroll', function () {
      if (!phone.matches || !panel.hidden) return;
      var y = scrollY, dy = y - lastY;
      if (Math.abs(dy) < 6) return;
      lastY = y;
      tuck(dy > 0 && y > 120);
      clearTimeout(idle);
      idle = setTimeout(function () { tuck(false); }, 1200);
    }, { passive: true });
    launch.addEventListener('click', function (e) {
      if (!launch.classList.contains('is-tucked')) return;
      e.stopImmediatePropagation(); e.preventDefault();
      tuck(false);
    }, true);
    place(); setTimeout(place, 400);  // at once, so the pill never flashes over a bar on load
    if (window.PipChat.wantsOpen()) { open(); resume(); }
    /* First page of a visit: say "Ask Pip" for a moment, then just the head. */
    var landed = true;
    try { landed = !sessionStorage.getItem('pipw:seen'); sessionStorage.setItem('pipw:seen', '1'); } catch (e) {}
    if (landed) setTimeout(function () { launch.classList.add('is-mini'); }, 4500);
    else launch.classList.add('is-mini');
    launch.setAttribute('aria-label', 'Ask Pip');
    launch.hidden = false;
  }
})();
